import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Container, Grid } from '@mui/material';
import styled from "@emotion/styled";

const drawerWidth = 240;
const navItems = [  {
  title: 'Home',
  link: '#pacman'
},
{
  title: 'About',
  link: '#about'
},
{
  title: 'Partners',
  link: '#partners'
},
{
  title: 'Tokenomics',
  link: '#tokenomics'
},
{
  title: 'Road Map',
  link: '#roadmap'
},
{
  title: 'Faq',
  link: '#faq'
}
];

const NavContainer = styled(Container)`
    background:#2F468C;
    display: flex;
    flex-direction: column;
    justify-content: center;
`
const MenuLinks = styled(Button)`
  Color:#fff;
  font-size:14px;
  font-family:Emulogic-zrEw;
  font-weight:400;
  margin:0px 5px 0px 5px;
  padding: 25px 10px 25px 10px;
  border-radius:10px;
  text-transform:none;
  @media (max-width: 1250px) and (min-width: 900px){
    font-size:12px;
  }
`
const MobileMenu = styled(ListItemText)`
  span {
    Color:#fff;
    font-size:16px;
    font-family:Emulogic-zrEw;
    font-weight:400;
  }
`

const NavBar = styled(AppBar)`
  position:inherit;
  background:#2F468C;
  top:unset;
  box-shadow:none;
  @media (max-width: 900px){
    position: absolute;
    padding-left: 20px !important;
  }
  .Tool{
    padding:0px;
  }
  svg{
    color:#000;
    width:2rem;
    height:2rem;
    background-color:yellow;
    border-radius:10px;
  }
`
const MenuToggle = styled(IconButton)`
  .css-vubbuv{
    Color: #000;
    width:2rem;
    height:2rem;
  }
`

const DesktopMenuWrapper = styled(Grid)`
  justify-content: space-between;
  padding:10px 15px;
  border-radius:25px;
  @media (min-width: 2000px){
      padding:20px 30px;
    }
`

const LogoLink = styled.a`
    text-decoration:none;
    display:Flex;
    align-items: center;
`
const DesktopLogo = styled.img`
    @media (max-width: 1250px) and (min-width: 900px){
    width:150px;
    max-width:100%;
    }
`
const MobileLogo = styled.img`
      width: 150px;
      max-width: 150px;
      height: auto;
      padding-top:10px;
      padding-bottom:5px;
`
const SocialWrapper = styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 900px){
        justify-content:center;
    }
`
const SocialImg = styled.img`
    margin:0px 5px;
    @media (max-width: 1250px) and (min-width: 900px){
    width:40px;
    max-width:100%;
    }
    @media (max-width: 900px){
        width:30px;
        height:auto;
        max-width:100%;
    }
`
const SocialA = styled.a`
    display:flex;
    align-items:center;
`
const MobileBox = styled(Box)`
    background-color:#2F468C;
    hr{
        border-color:#fff;
    }
`
const NavToolbar = styled(Toolbar)`
    justify-content: center;
`
const DrawerAppBar = (props) => {
  const { window, parrentMenuTheme } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <MobileBox onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <MobileLogo src="./assets/pacman-logo.png" alt="" />
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton href={item.link} sx={{ textAlign: 'center' }}>
              <MobileMenu primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
            <SocialWrapper>
                  <a href=" https://twitter.com/pacman_plus"><SocialImg src="./assets/twitter.png" /></a>
                  <a href="https://t.me/pacman_plus_Eth"><SocialImg src="./assets/telegram.png" /></a>
            </SocialWrapper>
    </MobileBox>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <NavContainer maxWidth="xxl">
    <Grid container sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavBar component="nav" >
        <NavToolbar className='Tool'>
          <Grid item sm={12} xs={12} sx={{ mr: 2, display: { md: 'none' , xs: 'flex' } , justifyContent: 'space-between' }}>
            <LogoLink href="/">
            <MobileLogo src="./assets/pacman-logo.png" alt="" />
            </LogoLink>
          <MenuToggle
            menutheme={parrentMenuTheme}
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            
          >
            <MenuIcon />
          </MenuToggle>
          </Grid>
          <DesktopMenuWrapper item  xs={12} md={12} xl={10} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' }  }}>
              <LogoLink href="/">
                <DesktopLogo src="./assets/pacman-logo.png" alt="" />
              </LogoLink>
          <Box sx={{display: 'flex' , alignItems: 'center'}}>
            {navItems.map((item) => (
              <MenuLinks key={item.title} href={item.link} >
              {item.title}
              </MenuLinks>
            ))}
            <SocialWrapper>
                  <SocialA href=" https://twitter.com/pacman_plus"><SocialImg src="./assets/twitter.png" /></SocialA>
                  <SocialA href="https://t.me/pacman_plus_Eth"><SocialImg src="./assets/telegram.png" /></SocialA>
            </SocialWrapper>
          </Box>
          </DesktopMenuWrapper>
        </NavToolbar>
      </NavBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Grid>
    </NavContainer>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;